export default __webpack_public_path__ + "static/media/hair-5-1.759a20f8.svg";